<div class="modal active">
  <div class="modal__container modal__container--lg support-ticket-modal">
    <div class="fields">
      <h2>Support Tickets</h2>

      <div class="close" (click)="close()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>

      <div class="fields__container">
        <div class="fields__block">
          <div class="fields__block__section">
            <div
              class="support-ticket-layout"
              [class.support-ticket-layout--list]="!selectedDetails">

              <section class="ticket-list-panel">
                <div class="ticket-toolbar">
                  <input
                    type="text"
                    class="ticket-search"
                    placeholder="Search tickets..."
                    [(ngModel)]="filters.search"
                    (input)="applyFilters()" />

                  <select
                    class="ticket-status-filter"
                    [(ngModel)]="filters.status"
                    (change)="applyFilters()">
                    <option value="">All status</option>
                    <option *ngFor="let status of statuses" [value]="status">
                      {{ getStatusLabel(status) }}
                    </option>
                  </select>

                  <select
                    class="ticket-type-filter"
                    [(ngModel)]="filters.type"
                    (change)="applyFilters()">
                    <option value="">All types</option>
                    <option *ngFor="let ticketType of ticketTypes" [value]="ticketType">
                      {{ getTicketTypeLabel(ticketType) }}
                    </option>
                  </select>

                  <button
                    type="button"
                    class="toolbar-icon-btn"
                    title="Refresh tickets"
                    (click)="loadTickets()"
                    [disabled]="loading">
                    <img src="/assets/img/refresh-icon.svg" alt="" />
                  </button>

                  <button
                    type="button"
                    class="toolbar-new-ticket-btn"
                    (click)="openNewTicket()">
                    <img src="/assets/img/create-white.svg" alt="" />
                    <span>New Ticket</span>
                  </button>

                  <button
                    *ngIf="isAdmin"
                    type="button"
                    class="toolbar-scope-btn"
                    (click)="toggleAllTickets()"
                    [disabled]="loading">
                    {{ showAllTickets ? 'My Tickets' : 'All Tickets' }}
                  </button>
                </div>

                <div class="ticket-list">
                  <button
                    type="button"
                    class="ticket-row"
                    *ngFor="let ticket of pagedTickets; trackBy: trackByTicketId"
                    [class.selected]="ticket.id === selectedTicketId"
                    (click)="selectTicket(ticket)">

                    <div class="ticket-row__top">
                      <span class="ticket-title" [title]="ticket.title">{{ ticket.title }}</span>
                      <span class="ticket-id" *ngIf="ticket.id">{{ getTicketDisplayId(ticket.id) }}</span>
                    </div>

                    <div class="ticket-row__meta">
                      <span class="ticket-status" [ngClass]="getStatusClass(ticket.status)">
                        {{ getStatusLabel(ticket.status) }}
                      </span>

                      <span class="ticket-type">
                        {{ getTicketTypeLabel(ticket.ticketType) }}
                      </span>

                      <span *ngIf="isAdmin">{{ ticket.createdBy || 'Unknown user' }}</span>

                      <span>{{ ticket.updatedAt || ticket.createdAt | date:'yyyy-MM-dd HH:mm' }}</span>
                    </div>
                  </button>

                  <div class="empty-state" *ngIf="!loading && filteredTickets.length === 0">
                    No tickets found.
                  </div>
                </div>

                <div class="ticket-pagination" *ngIf="filteredTickets.length > pageSize">
                  <div class="ticket-pagination__info">
                    {{ pageStart }}-{{ pageEnd }} of {{ filteredTickets.length }}
                  </div>

                  <div class="ticket-pagination__actions">
                    <button
                      type="button"
                      class="pagination-btn"
                      (click)="previousPage()"
                      [disabled]="currentPage === 1">
                      Previous
                    </button>

                    <span class="ticket-pagination__page">
                      Page {{ currentPage }} of {{ totalPages }}
                    </span>

                    <button
                      type="button"
                      class="pagination-btn"
                      (click)="nextPage()"
                      [disabled]="currentPage === totalPages">
                      Next
                    </button>
                  </div>
                </div>
              </section>

              <section class="ticket-detail-panel" *ngIf="selectedDetails as details">
                <div class="detail-breadcrumb">
                  <button
                    type="button"
                    class="detail-back-link"
                    (click)="backToList()">
                    Support Tickets
                  </button>
                  <span *ngIf="details.ticket.id">/ {{ getTicketDisplayId(details.ticket.id) }}</span>
                </div>

                <div class="detail-header">
                  <div>
                    <h3>{{ details.ticket.title }}</h3>

                    <div class="detail-meta">
                      <span>{{ details.ticket.createdBy || 'Unknown user' }}</span>
                      <span>{{ details.ticket.createdAt | date:'yyyy-MM-dd HH:mm' }}</span>

                    </div>
                    <div class="ticket-info-row">
                      <div class="user-status-row">
                        <span>Status:</span>
                        <span class="ticket-status" [ngClass]="getStatusClass(details.ticket.status)">
                          {{ getStatusLabel(details.ticket.status) }}
                        </span>
                      </div>

                      <div class="user-status-row">
                        <span>Type:</span>
                        <span class="ticket-type">
                          {{ getTicketTypeLabel(details.ticket.ticketType) }}
                        </span>
                      </div>
                    </div>

                    <div class="admin-status-panel" *ngIf="isAdmin">
                      <label for="ticket-status-select">Change status</label>
                      <select
                        id="ticket-status-select"
                        [(ngModel)]="selectedStatus"
                        (ngModelChange)="onStatusChange($event)"
                        [disabled]="savingStatus">
                        <option *ngFor="let status of statuses" [ngValue]="status">
                          {{ getStatusLabel(status) }}
                        </option>
                      </select>

                      <button
                        *ngIf="hasPendingStatusChange()"
                        type="button"
                        class="blue status-save-btn"
                        (click)="saveStatusChange()"
                        [disabled]="savingStatus">
                        Save
                      </button>
                    </div>
                  </div>
                </div>

                <div class="detail-section">
                  <h4>Description</h4>
                  <div class="ticket-description">
                    {{ details.ticket.description }}
                  </div>
                </div>

                <div class="detail-columns">
                  <section>
                    <h4>Comments</h4>

                    <div class="comment-list" #commentList>
                      <div class="comment-row" *ngFor="let comment of details.comments">
                        <div class="comment-meta">
                          <strong>{{ comment.createdBy || 'Unknown user' }}</strong>
                          <span>{{ comment.createdAt | date:'yyyy-MM-dd HH:mm' }}</span>
                        </div>
                        <p>{{ comment.comment }}</p>
                      </div>

                      <div class="empty-state" *ngIf="details.comments.length === 0">
                        No comments yet.
                      </div>
                    </div>

                    <ng-container *ngIf="!isReadOnlyStatus(details.ticket.status)">
                      <textarea
                        rows="3"
                        placeholder="Add a new comment..."
                        [(ngModel)]="newComment">
                      </textarea>

                    <button
                        type="button"
                        class="blue comment-submit-btn"
                        (click)="addComment()"
                        [disabled]="savingComment || !newComment.trim()">
                        <img src="/assets/img/create-white.svg" alt="" />
                        <span>Add Comment</span>
                      </button>
                    </ng-container>
                  </section>

                  <section>
                    <h4>Attachments</h4>

                    <div class="attachment-list">
                      <div class="attachment-row" *ngFor="let item of details.attachments">
                        <div class="attachment-info">
                            <strong>{{ item.fileName }}</strong>
                            <div class="attachment-meta">
                              <span>{{ item.contentType }}</span>
                              <span>{{ formatFileSize(item.fileSize) }}</span>
                              <span>{{ item.uploadedAt | date:'yyyy-MM-dd HH:mm' }}</span>
                            </div>
                          </div>

                          <div class="attachment-actions">
                            <button
                              type="button"
                              class="attachment-download-btn"
                              title="Download attachment"
                              [disabled]="isDownloadingAttachment(item.id) || !item.id"
                              (click)="downloadAttachmentFromTicket(item)">
                              <img src="/assets/img/download-blue-icon2.svg" alt="Download" />
                            </button>

                          <button
                            *ngIf="!isReadOnlyStatus(details.ticket.status)"
                            type="button"
                            class="attachment-remove-btn"
                            title="Remove attachment"
                            [disabled]="savingAttachment || !item.id"
                            (click)="removeAttachmentFromTicket(item.id)">
                            <img src="/assets/img/trash-icon.svg" alt="Remove" />
                          </button>
                        </div>
                      </div>

                      <div class="empty-state" *ngIf="details.attachments.length === 0">
                        No attachments yet.
                      </div>
                    </div>
                    <ng-container *ngIf="!isReadOnlyStatus(details.ticket.status)">
                      <div class="attachment-upload-row">
                        <label class="file-select-btn">
                          <img src="/assets/img/upload-file-icon.svg" alt="" />
                          <span>Choose Files</span>

                          <input
                            type="file"
                            multiple
                            accept=".png,.jpg,.jpeg,.pdf,.txt,.log,.zip"
                            (change)="onFilesSelected($event)" />
                        </label>

                        <button
                          type="button"
                          class="upload-btn"
                          (click)="uploadAttachments()"
                          [disabled]="savingAttachment || selectedFiles.length === 0">
                          <span>Upload</span>
                        </button>
                      </div>

                      <div class="selected-files" *ngIf="selectedFiles.length">
                        {{ selectedFiles.length }} file(s) selected
                      </div>

                      <div class="attachment-help">
                        Max {{ maxFiles }} files, {{ maxTotalSizeMb }} MB total.
                      </div>
                    </ng-container>
                  </section>
                </div>
              </section>

            </div>
            </div>
          </div>
        <div class="fields__btn">
          <button
            *ngIf="selectedDetails"
            type="button"
            class="blue"
            (click)="backToList()">
            Back
          </button>
          <button type="button" class="gray" (click)="close()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
